<template>
    <CRow>
        <CCol col="12" xl="12">
            <CCard>
                <CCardHeader>
                    <strong>Создание тригерной рассылки</strong>
                </CCardHeader>
                <CCardBody>
                    <TriggerCampaignForm
                        :campaign="campaign"
                        :segments="segments"
                        :loading="loading"
                        @submit="handleSubmit"
                        @cancel="handleCancel"
                    />
                </CCardBody>
            </CCard>
        </CCol>
    </CRow>
</template>

<script>
    import Vue from 'vue';
    import TriggerCampaignForm from '../../components/trigger-campaigns/TriggerCampaignForm.vue';

    export default {
        name: 'TriggerCampaignCreate',

        components: {
            TriggerCampaignForm
        },

        data() {
            return {
                loading: false,
                segments: [],
                campaign: {
                    name: '',
                    segment_id: null,
                    trigger_type: 'registration',
                    trigger_days: 1,
                    trigger_hours: null,
                    send_time: '10:00',
                    push_title: '',
                    push_text: '',
                    click_url: '',
                    enabled: true
                }
            };
        },

        async mounted() {
            await this.loadSegments();
        },

        methods: {
            async loadSegments() {
                try {
                    const response = await Vue.axios.get('/segments');
                    this.segments = response.data.data || [];
                } catch (err) {
                    console.error('Ошибка загрузки сегментов:', err);
                    this.segments = [];
                }
            },

            async handleSubmit(campaignData) {
                this.loading = true;
                try {
                    await Vue.axios.post('/trigger-campaigns', campaignData);
                    this.$root.$emit('showSuccess', 'Тригерная рассылка создана.');
                    this.$router.push('/trigger-campaigns');
                } catch (err) {
                    this.$root.$emit('showError', 'Ошибка создания тригерной рассылки.');
                    console.error(err);
                } finally {
                    this.loading = false;
                }
            },

            handleCancel() {
                this.$router.push('/trigger-campaigns');
            }
        }
    };
</script>
